import { Link, useParams } from 'react-router-dom';
import classNames from 'classnames';

import { useGetForecast } from 'hooks/useGetForecast';
import Alert, { AlertVariant } from 'components/common/alerts/Alert';
import Location from '../location/Location';
import Icon, { Icons } from 'components/common/icons/Icon';
import WeatherAlert from './WeatherAlert';

function WeatherAlertsPage() {
  const { lat, lon } = useParams();
  const {
    data: weather,
    isError,
    isLoading,
    isRefetching,
  } = useGetForecast(Number(lat), Number(lon));

  if (isError) {
    return (
      <Alert variant={AlertVariant.Error} className="mx-auto max-w-sm">
        <div>Unable to retrieve the current conditions.</div>
        <div>Please refresh or try again later.</div>
      </Alert>
    );
  }

  const hasAlerts = weather?.providerData.alerts.alert.length;
  const alertCount = weather?.providerData.alerts.alert.length;

  return (
    <div className="mx-auto max-w-lg" data-testid="page-weather-alerts">
      <div className="flex items-center justify-between">
        <Location
          isLoading={isLoading}
          location={weather?.providerData.location}
          className="grow"
        />
        <Icon
          name={Icons.TriangleExclamation}
          size="xl"
          className={classNames('ml-2 text-red-800/90', { hidden: !hasAlerts })}
        />
        <Icon
          name={Icons.Rotate}
          spin
          size="xl"
          className={classNames('ml-2', { hidden: !isRefetching })}
        />
      </div>
      <div className="mb-4">
        <Link to=".." relative="path" className="text-sm text-blue-500 hover:opacity-50">
          <Icon name={Icons.ArrowLeft} className="mr-1" />
          Back to forecast
        </Link>
      </div>

      <div className="relative mb-4 inline-block">
        <div className="text-2xl">Alerts</div>
        <div className="absolute left-[70px] top-0 rounded-full bg-red-800/90 px-1 py-0.5 text-xs/3 font-bold text-white dark:text-inherit">
          {alertCount}
        </div>
      </div>

      {!hasAlerts && <div className="mb-6">There are no active weather alerts.</div>}

      {hasAlerts && (
        <div className="mb-6">
          {weather.providerData.alerts.alert.map((alert, index) => (
            <WeatherAlert key={index} alert={alert} className="mb-6 last:mb-0" />
          ))}
        </div>
      )}
    </div>
  );
}

export default WeatherAlertsPage;
